import type {
  GetAiAuditByIdQuery,
  GetAiAuditByIdQueryVariables,
  GetAiAuditFilterOptionsQuery,
  GetAiAuditFilterOptionsQueryVariables,
  GetAiAuditsQuery,
  GetAiAuditsQueryVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const GET_AI_AUDITS: TypedDocumentNode<
  GetAiAuditsQuery,
  GetAiAuditsQueryVariables
> = gql`
  query GetAiAudits($limit: Int, $endpoint: String, $context: String) {
    aiAudits(limit: $limit, endpoint: $endpoint, context: $context) {
      id
      createdAt
      endpoint
      context
    }
  }
`;

export const GET_AI_AUDIT_FILTER_OPTIONS: TypedDocumentNode<
  GetAiAuditFilterOptionsQuery,
  GetAiAuditFilterOptionsQueryVariables
> = gql`
  query GetAiAuditFilterOptions {
    aiAuditFilterOptions {
      endpoints
      contexts
    }
  }
`;

export const GET_AI_AUDIT_BY_ID: TypedDocumentNode<
  GetAiAuditByIdQuery,
  GetAiAuditByIdQueryVariables
> = gql`
  query GetAiAuditById($id: String!) {
    aiAudit(id: $id) {
      id
      createdAt
      endpoint
      context
      input
      output
    }
  }
`;
